// 1. 외부 패키지
import Axios, { AxiosRequestConfig, CancelToken } from "axios";
import { METADATA_URL, GET, JSON_HEADER } from "../../shared/api-constant";

// 2. 프로젝트 내부 alias


// 3. 상대 경로


// 4. 타입


const metadata = {
  getMetadata: (type: string, cancel_token: CancelToken) => {
    const config: AxiosRequestConfig = {
      url: `${METADATA_URL}/get_metadata.php`,
      method: GET,
      params: {
        type,
      },
      headers: {
        ...JSON_HEADER,
      },
      cancelToken: cancel_token,
    };
    return Axios(config);
  }
};

export default metadata;